export default __webpack_public_path__ + "static/media/thankyou-page-banner.7129f8f6.svg";